import dayjs from 'dayjs';

export const FormatDate = date => dayjs(date).format('YYYY-MM-DD');
